exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.notification-badge[data-v-9194f266]{position:relative;color:#fff;border-radius:50%\n}\n.view-all-center[data-v-9194f266]{text-align:center\n}\n.view-all-link[data-v-9194f266]{cursor:pointer;margin:0 5px;position:relative;top:3px;transition:all .5s;width:20px\n}", ""]);

// exports
